import React from "react";

import "./Card.css";

const card = props => (
  <div className="card" style={props.styles}>
    <div className="card-head">{props.children}</div>
    <div className="card-body">
      <h1 className="centerText">{props.title}</h1>
      {props.body}
    </div>
    <div className="card-bottom" />
  </div>
);

export default card;



// WEBPACK FOOTER //
// ./src/components/UI/Card.js